import { createPostEndpoint } from '@sonar-software/sonar-http';

export type PostAcceptInvitationRequest = {
    verificationToken: string;
	password: string;
};

export type PostAcceptInvitationResponse = {
    token: string;
};

export const postAcceptInvitation = createPostEndpoint<PostAcceptInvitationRequest, PostAcceptInvitationResponse>(
	'/api/v3/security/authentication/accept-invitation'
);
